import React from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomInput from "../../components/Form/Input";
import CustomButton from "../../components/Form/CustomButtonWithHover";
import { requestLink } from "../../store";
import { useThunk } from "../../hooks/useThunk";
import useForm from "../../hooks/useForm";
import { COMMON_FIELD_TYPES } from "../../constants/fieldTypes";
import showToast from "../../utils/toastNotifications";

const ForgotPasswordForm = () => {
  const [doResetPassword, isResettingPassword] = useThunk(requestLink);
  const navigate = useNavigate();

  const {
    formData,
    errors,
    touched,
    handleInputChange,
    handleBlur,
    validateForm,
    setTouched,
    clearError,
  } = useForm(
    {
      emailOrPhone: "",
    },
    {
      emailOrPhone: true,
    },
    {
      emailOrPhone: COMMON_FIELD_TYPES.EMAIL_OR_PHONE,
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched({ emailOrPhone: true });

    const isValid = validateForm();
    if (isValid) {
      const result = await doResetPassword(formData);
      if (result?.success) {
        showToast("success", result?.response?.message || "Reset link sent");
      } else {
        showToast("error", result?.response?.message || "Failed to send link");
      }
    }
  };

  return (
    <div className="flex flex-col justify-center items-center my-auto p-2 lg:p-6">
      <h1 className="self-start text-level-4 md:text-level-3 lg:text-level-2 xl2:text-[48px] font-semibold font-poppins">
        <span className="text-black">Forgot </span>
        <span className="text-roselea-green-1">Password</span>
      </h1>

      <form
        className="flex flex-col justify-center items-center"
        onSubmit={handleSubmit}
      >
        <div className="flex flex-col gap-3 mt-[40px]">
          <p className="text-level-6 lg:text-level-5 font-[400] text-[#5C5F6A] font-poppins">
            Please enter your registered Email Address or Phone number
          </p>

          <CustomInput
            label={""}
            type="email"
            name="email"
            placeholder="Enter Your Email/ Phone Number"
            value={formData.emailOrPhone}
            error={touched.emailOrPhone && errors.emailOrPhone}
            onChange={(e) => handleInputChange("emailOrPhone", e.target.value)}
            onBlur={() => handleBlur("emailOrPhone", formData.emailOrPhone)}
            onFocus={() => clearError("emailOrPhone")}
            className="w-[260px] sm:w-[380px] lg:w-[400px] xl2:w-[512px] h-[40px] px-3 rounded-[12px] border border-input-border-roselea-green bg-primary-light/30 text-gray-600"
            labelStyle="font-alexandria font-medium  sm:text-[16px] text-dark"
            inputStyle="bg-input-roselea-green bg-opacity-[0.03]"
            isRequired={true}
          />
        </div>

        <div className="flex flex-col gap-2 justify-center items-center">
          <CustomButton
            type="submit"
            loading={isResettingPassword}
            className="h-[40px] xl2:h-[60px] w-[260px] sm:w-[380px] lg:w-[400px] xl2:w-[512px] text-level-6 xl2:text-[20px] text-white font-poppins font-semibold bg-roselea-green-1 mt-[50px] rounded-xl"
            buttonText="Send Reset Link"
            onClick={handleSubmit}
          />
          <Link
            to="/"
            className="font-medium font-alexandria underline text-roselea-green-1 text-[12px] sm:text-[16px] hover:no-underline"
          >
            Back to Sign in
          </Link>
        </div>
      </form>
    </div>
  );
};

export default ForgotPasswordForm;
